 <!-- Common Modal -->
 <div class="modal fade" id="popupModal" role="dialog" #template1>
  <div class="modal-dialog modal-dialog-centered">
  
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        
        <h5 class="modal-title">{{btnText | titlecase}} {{txtModule}} </h5>
        <button type="button" class="close" data-bs-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body ptb24">
          <p class="mb-0">Are you sure you want to {{btnText}} the {{txtModule}}?</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal">No</button>
        <button type="button" class="btn btn-primary" (click)="btnClick($event)" data-bs-dismiss="modal">Yes</button>
      </div>
    </div>
    
  </div>
</div>

